import React, { useState } from "react";
import { Link } from "react-scroll";
import {
  ListItem,
  List,
  makeStyles,
  IconButton,
  Toolbar,
  Drawer,
} from "@material-ui/core";

import flare from "../../Assets/flareBottom.png";
import MenuIcon from "@material-ui/icons/Menu";

import "../../CSS/Menu.css";

const useStyles = makeStyles((theme) => ({
  active: {
    backgroundImage: `url(${flare})`,
    backgroundPosition: "center bottom",
    backgroundRepeat: "no-repeat",
    backgroundSize: "200px 100px",
    transition: "all 0.5s ease",
  },
}));

export default function MobileNavbar(props) {
  const items = props.items;

  const [drawerOpen, setDrawerOpen] = useState(false);

  const classes = useStyles();

  return (
    <Toolbar style={{ position: "fixed" }}>
      <IconButton
        {...{
          edge: "start",
          color: "inherit",
          "aria-label": "menu",
          "aria-haspopup": "true",
          onClick: () => setDrawerOpen(!drawerOpen),
        }}
      >
        <MenuIcon color="secondary" />
      </IconButton>
      <Drawer
        {...{
          anchor: "top",
          open: drawerOpen,
          onClose: () => setDrawerOpen(!drawerOpen),
          Paper: { backgroundColor: "red" },
        }}
      >
        <div className="listOutterDivMobile">
          <List className="listMobile">
            {items.map((item) => {
              return (
                <ListItem
                  button
                  spy
                  smooth
                  offset={-200}
                  activeClass={classes.active}
                  component={Link}
                  to={item}
                  key={item}
                  onClick={() => setDrawerOpen(!drawerOpen)}
                >
                  {item}
                </ListItem>
              );
            })}
          </List>
        </div>
      </Drawer>
    </Toolbar>
  );
}
